import { render, staticRenderFns } from "./Riders.vue?vue&type=template&id=0fe98f50&scoped=true&"
import script from "./Riders.vue?vue&type=script&lang=ts&"
export * from "./Riders.vue?vue&type=script&lang=ts&"
import style0 from "./Riders.vue?vue&type=style&index=0&id=0fe98f50&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe98f50",
  null
  
)

export default component.exports